<template lang='pug'>
v-main
  v-container(fluid)
    v-flex
      v-card.pt-2
        v-select.col-12(
          label="Business Unit",
          :items="im.bisnis_unit",
          item-value="value",
          v-model="bisnisUnit",
          hide-details
        )
        v-text-field.col-12(
          flat,
          append-icon="search",
          placeholder="Keyword (optional)",
          v-model="keyword",
          hide-details
        )

        p(v-if="!im.tableApproval" style="color: black;margin: 0.7rem;font-family: Roboto;font-size: 10px;font-style: italic;font-weight: 400;line-height: 12px;letter-spacing: 0em;text-align: left;")
          span(style="color:red") *
          | Only show for the last 60 days
        //- v-tabs(class='pb-3' color="transparent" slider-color="red" left)
        //-   v-tab() Need Approval
        //-   v-tab() approved
        //-   v-tab() Rejected

        //- BUTTON SELECT ALL

        div(style="display: flex; justify-content: space-between;")
          v-btn(style="flex:1" v-if="selectedM.length > 0 && typeTab == 'pending'" class="ml-2 mb-0" dense color="primary" dark @click="approvalDialog=true;approval='7';genOtp()")
            v-icon(title="Approval") assignment_turned_in
            |&nbsp; Approve / Reject

          p(v-if="selectedM.length>0 && typeTab == 'pending'" style="flex:1;margin: auto; text-align: center;") {{selectedM.length}} Selected

        v-btn.ml-2.mb-4(
          v-if="selected.length > 0 && typeTab == 'pending'",
          dense,
          color="primary",
          dark,
          @click="approvalDialog = true; approval = '7'; genOtp()"
        )
          v-icon(title="Approval") assignment_turned_in
          | &nbsp; Approve / Reject

        v-dialog(v-model="approvalDialog", persistent, max-width="500px")
          v-card
            v-card-title.headline.grey.lighten-3.mb-3 Approval Form
            v-card-text
              v-layout(wrap)
                v-flex(xs12)
                  v-alert(v-if="alert_otp && !alert_otp_error" type="success") The OTP code has been successfully sent to your email and whatsapp.
                  v-alert(v-if="alert_otp_error" type="error")  OTP code is incorrect!
                v-flex(xs12)
                  v-radio-group(v-model="approval", row)
                    v-radio(label="Approve" color="success" value="7")
                    v-radio(label="Reject" color="red" value="8")

                v-flex(xs12)
                  v-textarea.mt-3(
                    v-model="comment",
                    filled,
                    label="Comment (Optional)",
                    counter="150",
                    :rules="[rules.length(150)]"
                  )
                v-flex(xs12)
                  span Enter the OTP code for {{ numberIm.toString().replaceAll("\\p{P}", "") }}
                  div(
                    style="display: flex; flex-direction: row; margin-left: -10px"
                  )
                    VinputOtp(
                      ref="otpInput",
                      separator="-",
                      :num-inputs="4",
                      :should-auto-focus="true",
                      :is-input-num="true",
                      @on-change="otpOnChange",
                      @on-complete="handleOnComplete"
                    ) 
            v-card-actions.pb-5
              v-spacer
              v-btn(
                color="green",
                depressed,
                @click="resendOtp()",
                style="color: white"
              ) Resend OTP
              v-btn.pl-4.pr-4(
                style="margin-right: 6px",
                depressed,
                @click="handleClose"
              )
                | Close
              .text-xs-center
              v-btn.pl-4.pr-4(
                :disabled="(approval == null && approval == 3) || (comment != null && comment.length > 150) || otpcode == null || otpcode == '' || otpcode.length < 4",
                color="blue-secondary",
                depressed,
                @click="multiLoading = true; SubmitApprove()"
              ) Submit
              v-dialog(v-model="multiLoading", persistent, width="300")
                v-card(color="primary", dark)
                  v-card-text Processing. Please wait!
                    v-progress-linear.mb-0(indeterminate, color="white")

        v-card-text.pa-0
          div(v-if="isMobile" :class="{ isNotNeedApproval: !im.tableApproval }")
            //- HEAD
            div(style="display: flex" )
              v-checkbox(v-if="im.tableApproval" @click="selectAllCheckBoxMobileView()" v-model="selectAllMobile" style="width:24px; margin: 1rem; margin-left:.4rem; font-size: 14px; padding: 0.2rem")
              p(
                style="flex: 1; margin-bottom: 1rem;margin-top: 1rem; font-weight: bold; font-size: 14px; padding: 0.2rem",
                v-for="header in im.headers"
              ) {{ header.text }}
            //- BODY
            div(v-for="item in im.items" :key="item._id")
              div(style="display: flex; border-top: 1px solid #d1c6c6;")
                v-checkbox(v-if="im.tableApproval && item.imStatus != '3'" v-model="item.checked" @click="selectCheckBoxMobileView(item)" style=" margin: .5rem 0rem 0rem 0.4rem; font-size: 14px; padding: 0.2rem")
                v-icon(style="margin: 0 0.6rem;" v-if="im.tableApproval && item.imStatus == '3'") assignment_late
                a(
                  v-if="item.imStatus != 3"
                  @click="getPreview(item._id)"
                  style="flex: 1; margin: 0; font-size: 14px; padding: 0.2rem"
                ) {{ item.imNo }}
                a(
                  v-if="item.imStatus == 3"
                  @click="getPreview(item._id)"
                  style="flex: 1; margin: 0; font-size: 14px; padding: 0.2rem"
                ) <span style ="color:#FB8C00">[Need Review]</span> {{ item.imNo }}
                p(
                  style="flex: 1; margin: 0; color:#000; font-size: 14px; padding: 0.2rem"
                ) {{ item.imOrganization.name }}
                p(
                  v-if="typeTab == 'pending'"
                  style="flex: 1; margin: 0; color:#000; font-size: 14px; padding: 0.2rem"
                ) {{ item.imDate.substring(0, 10) }}
                p(
                  v-if="typeTab != 'pending'"
                  style="flex: 1; margin: 0; color:#000; font-size: 14px; padding: 0.2rem"
                ) {{ item.subtDateAR.substring(0, 10) }}
              div(:class="{ isNotNeedApprovalSubject: !im.tableApproval }" style=" color:#000; margin:0rem .5rem 1rem .5rem" v-if="item.imPerihal.length <= maxLength") {{item.imPerihal}}
              div(v-else)
                div(:class="{ isNotNeedApprovalSubject: !im.tableApproval }" style=" color:#000; margin:0rem .5rem 1rem .5rem" v-if="!showMore[item.imNo]") {{setShortPerihal(item.imPerihal)}}
                  a(style ="color:#fff;border: 1px solid #1976d2; background: #1976d2; padding: 0 0.4rem; border-radius: 20px;" v-if="item.imPerihal.length > 70" href="#" @click.prevent="toggleShowMore(item.imNo)") {{showMore[item.imNo] ? 'less' : 'more'}}
                div(:class="{ isNotNeedApprovalSubject: !im.tableApproval }" style=" color:#000; margin:0rem .5rem 1rem .5rem" v-else) {{item.imPerihal}}
                  a(style ="color:#fff;border: 1px solid #1976d2; background: #1976d2; padding: 0 0.4rem; border-radius: 20px;" v-if="item.imPerihal.length > 70" href="#" @click.prevent="toggleShowMore(item.imNo)") {{showMore[item.imNo] ? 'less' : 'more'}}
          
          //- DESKTOP
          v-data-table.elevation-1(
            id="dtablePenAppv"
            :class="{ isMobileClass: isMobile}"
            mobile-breakpoint="0"
            v-model="isMobile ? selectedM : selected",
            :rows-per-page-items=[8]
            :footer-props="{ 'items-per-page-options':[8], 'disable-items-per-page': true, 'page-text': 'Showing {0} to {1} of {2} total'}",
            ref="dTable",
            :headers="im.headers",
            :items="im.items",
            :page.sync="page",
            :options.sync="options",
            :server-items-length="im.jumlah",
            :loading="loading",
            loading-text="Loading... Please wait",
            item-key="_id",
            :sort-desc.sync="im.imDate",
            multi-sortBy,
            :show-select="im.tableApproval && !isMobile",
            :single-expand="false",
            @toggle-select-all="selectAllToggle",
            :expanded.sync="expanded"
          )


            template(v-slot:item.imNo='{ item }')
              template <a v-if="item.imStatus != 3" @click="getPreview(item._id)"> {{item.imNo}} </a>
              template <a v-if="item.imStatus == 3" @click="getPreview(item._id)"> <span style ="color:#FB8C00">[Need Review]</span> {{item.imNo}} </a>

            template(v-slot:item.data-table-select="{ item }")
              v-checkbox(v-if="item.imStatus != 3" :value="isSelected(item)" @change="toggleSelection(item)")
              v-icon(v-else  :value="isSelected(item)" @change="toggleSelection(item)") assignment_late



            template(v-slot:expanded-item="{ item }" )
              td(:colspan="4" )
                div( style="margin:1rem; margin-top:0; margin-left:0" v-if="item.imPerihal.length <= maxLength") {{item.imPerihal}}
                div(v-else)
                  div(style="margin:1rem; margin-top:0; margin-left:0" v-if="!showMore[item.imNo]") {{setShortPerihal(item.imPerihal)}}
                    a(style ="color:#fff;border: 1px solid #1976d2; background: #1976d2; padding: 0 0.4rem; border-radius: 20px;" v-if="item.imPerihal.length > 70" href="#" @click.prevent="toggleShowMore(item.imNo)") {{showMore[item.imNo] ? 'less' : 'more'}}
                  div(style="margin:1rem; margin-top:0; margin-left:0" v-else) {{item.imPerihal}}
                    a(style ="color:#fff;border: 1px solid #1976d2; background: #1976d2; padding: 0 0.4rem; border-radius: 20px;" v-if="item.imPerihal.length > 70" href="#" @click.prevent="toggleShowMore(item.imNo)") {{showMore[item.imNo] ? 'less' : 'more'}}

</template>
<style scoped>

.v-data-footer__icons-after::after{
content: " - Remember this";
}

.isNotNeedApprovalSubject {
  margin-left:.2rem !important;
}

.isNotNeedApproval {
  margin:1rem
}

.v-slide-group__content .v-tabs-bar__content {
  background-color: #ffffff !important;
}


.v-badge__badge {
  width: auto;
  border-radius: 12px;
  padding: 5px;
}
</style>

<script>
//import io from "socket.io-client";
import axios from "axios";
import * as i18n from "../data/i18n.json";
import IMView from "@/components/IMViewApproval.vue";
import ProposalView from "@/components/ProposalView.vue";
import modal from "@/components/IMModal.vue";
import ApprovalDialog from "@/components/ApprovalDialog.vue";
import PiprTrack from "@/components/PiprTrack.vue";
import ChangeManagementNotif from "@/components/ChangeManagementNotif.vue";
import VinputOtp from "@/components/OtpInput.vue";

import { mapState } from "vuex";
export default {
  name: "IMListApproval",
  components: {
    IMView,
    ProposalView,
    ApprovalDialog,
    PiprTrack,
    modal,
    ChangeManagementNotif,
    VinputOtp,
  },
  props: {
    title: String,
    listType: String,
    dialogType: String,
    color: String,
    im: Object,
    typeTab: String,
  },

  data() {
    return {
      selectAllMobile:false,
      itemsPerPage: 8,
      page: 1,
      i18n: i18n.default,
      dialog: false,
      e1: "",
      e2: "",
      e6: 0,
      keyword: "",
      request: null,
      options: {
        sortBy: ["imDate"],
        sortDesc: [true],
      },
      imStat: "",
      wizardType: null,
      loading: false,
      bisnis_unit: [
        {
          text: "All",
          value: "",
        },
        {
          text: "Other",
          value: "other",
        },
      ],
      bisnisUnit: "",
      // group: 'bcg'
      expanded: [],
      category: "",
      selected: [],
      selectedM: [],
      selectedMBool: false,
      showMore: {},
      maxLength: 10,
      isMobile: false,
      approvalDialog: false,
      rules: {
        length: (len) => (v) =>
          (v || "").length <= len || `Comment must be less than 150 characters`,
      },
      otpcode: null,
      comment: null,
      approval: null,
      numberIm: [],
      alert_otp: false,
      alert_otp_error: false,
      multiLoading: false,
      length_data: [],
    };
  },
  created() {
    this.color = this.themeColor;
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  mounted() {
    const para = document.createElement("p");
    const node = document.createTextNode("Pending Approval");
    para.style.marginBottom = 0
    para.style.fontFamily = 'Roboto'
    para.style.fontSize = '16px'
    para.style.fontWeight = '700'
    para.style.marginLeft = '.5rem'
    para.appendChild(node);
    document.getElementsByClassName('v-toolbar__content')[0].appendChild(para)
    document.getElementsByClassName('v-tabs-bar__content')[0].style.backgroundColor = '#fff'
    
    this.onResize();
    this.getOptions()
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  watch: {

    options(val){
      this.itemsPerPage = val.itemsPerPage
      this.options.itemsPerPage=val.itemsPerPage
      this.options.rowsPerPage=val.itemsPerPage
      this.selectedM=[]
      this.selectAllMobile=false
      this.getOptions()
    },
    typeTab(){
      this.bisnisUnit = ''
      this.category = ''
      this.keyword=''
      this.options.page = 1
      this.options.itemsPerPage=8
      this.options.rowsPerPage=8
      this.selected=[]
      this.getOptions()
    },

    keyword() {
      // this.getPagination();
      this.getOptions();
    },
    bisnisUnit() {
      this.page = 1;
      // this.getPagination();
      this.getOptions();
    },

    isMobile(val) {
      if (val == false) {
        this.selected = this.selectedM
        this.selectedM = []
      }
      else {
        this.selectedM = this.selected
        this.selected = []
        setTimeout(()=> {
          document.querySelector(".isMobileClass .v-data-table__wrapper") ? document.querySelector(".isMobileClass .v-data-table__wrapper").remove(): null;
          if (document.querySelector(".v-slide-group__prev--disabled")) document.querySelector(".v-slide-group__prev--disabled").remove();
          const msgs = document.querySelectorAll(".v-messages.theme--light")
          for (let i in msgs) {
            if (msgs[i].remove)msgs[i].remove()
          }
        },1000)
      }
    },
    category() {
      this.page = 1;
      this.getOptions();
    },
    selected(val) {
      this.numberIm = [];
      // this.numberIm.push(val)
      if (val.length == 9) {
        this.selected.splice(val, 1);
      }
      if (val.length > 8) {
        val.length = 8;
      }

      for (var i = 0; i < val.length; i++) {
        this.numberIm.push(val[i].imNo);
        if (val[i].imStatus === 3) {
          val.splice(i, 1);
        }
      }
    },
  },
  computed: {


    selectAll() {
      return this.selected.length === this.im.items.length;
    },

    ...mapState(["dataUsers", "API_URL", "dataApprovalPending"]),
    search2: function () {
      return this.bisnisUnit + "_" + this.keyword;
    },
    filteredData: function () {
      let tujuan = this.tujuan_req;
      return tujuan.filter((x) => x.dep == this.e1);
    },
    dataCategory() {
      let result = [{ text: "All", value: "" }];
      for (const val of this.i18n.category) {
        result.push({
          text: val.text,
          value: val.value,
        });
      }
      return result;
    },
  },
  methods: {

    isSelected(item) {
      return this.selected.includes(item);
    },

    toggleSelection(item) {
      if (this.isSelected(item)) {
        this.selected = this.selected.filter(selectedItem => selectedItem !== item);
      } else {
        this.selected.push(item);
      }
    },

    initDT() {
      setTimeout(()=> {
        const arr = document.querySelectorAll("#dtablePenAppv.v-data-table>.v-data-table__wrapper tbody tr.v-data-table__expanded__content")
        const arr2 = document.querySelectorAll("#dtablePenAppv.v-data-table>.v-data-table__wrapper tbody tr.v-data-table__expanded__row .text-start")
        for (let i =0; i< arr.length; i++) {
          arr[i].style.boxShadow = 'none'
        }
        for (let i =0; i< arr2.length; i++) {
          arr2[i].style.borderBottom= 'none'
        }

        //- NEXT AND PREV BUTTON

        
        document.querySelector("#dtablePenAppv .v-data-footer .v-data-footer__pagination").style.fontSize = '14px'
        document.querySelector("#dtablePenAppv .v-data-footer .v-data-footer__pagination").style.margin ='0'
        document.querySelector("#dtablePenAppv .v-data-footer .v-data-footer__pagination").style.width ='100%'
        document.querySelector("#dtablePenAppv .v-data-footer .v-data-footer__pagination").style.textAlign ='end'
        document.querySelector("#dtablePenAppv .v-data-footer").style.justifyContent ='flex-end'

        document.querySelector("#dtablePenAppv .v-data-footer").style.padding ='1rem'
        //- 
        const backButton = document.querySelector("#dtablePenAppv .v-data-footer .v-data-footer__icons-before").children[0]
        backButton.innerHTML = 'Previous'
        backButton.style.width = '80px'
        backButton.style.backgroundColor = '#EAEAEA'
        backButton.style.color = '#000'
        backButton.style.borderRadius = '0'
        backButton.style.fontSize = '12px'

        document.querySelector('#dtablePenAppv .v-data-footer__icons-after .v-btn:first-child').style.margin= 0
        document.querySelector('#dtablePenAppv .v-data-footer__icons-before .v-btn:last-child').style.margin= 0

        const nextButton = document.querySelector("#dtablePenAppv .v-data-footer .v-data-footer__icons-after").children[0]
        nextButton.innerHTML = 'Next'
        nextButton.style.width = '80px'
        nextButton.style.backgroundColor = '#EAEAEA'
        nextButton.style.color = '#000'
        nextButton.style.borderRadius = '0'
        nextButton.style.fontSize = '12px'

      }, 20)
    },
    selectCheckBoxMobileView(item) {
      let result = []
      let unCentang = false

      for(let i in this.im.items) {
        if(this.im.items[i].checked == true) this.selectedM.push
      }
      // DETEKSI JIKA ID SUDAH ADA DALAM ARRAY
      for ( let i in this.selectedM ) {
        if (this.selectedM[i]._id == item._id) unCentang = true
      }
      if (unCentang) {
        for ( let i in this.selectedM ) {
          //- BRATI KETEMU / ADA
          if (this.selectedM[i]._id != item._id) result.push(this.selectedM[i])
        }
        this.selectedM = result
      } else {
        this.selectedM.push(item)
      }
      let noNeedReviewMemo = []
      for (let i in this.im.items) if (this.im.items[i].imStatus != 3) noNeedReviewMemo.push(this.im.items[i])
      const maxSelect = noNeedReviewMemo.length < this.itemsPerPage ?  noNeedReviewMemo.length : this.itemsPerPage
      if (maxSelect == this.selectedM.length) {

        this.selectAllMobile = true
      } else {
        this.selectAllMobile = false
      }
    },
    selectAllCheckBoxMobileView() {
      //- if (selected

      //- this.selectAllMobile = !this.selectAllMobile
      const maxSelect = this.im.jumlah < this.itemsPerPage ?  this.im.jumlah : this.itemsPerPage

      if (!this.selectAllMobile) {
        //- LOOP UNCENTANG SEMUA
        for(let i in this.im.items) {
          this.im.items[i].checked = false
          //- this.selectedM = []
        }
        this.selectedM = []
        this.selectedMBool = false
      } else {
        //- LOOP CENTANG SEMUA
        for(let i in this.im.items) {

          this.im.items[i].checked = true
        }
        let noNeedReviewMemo = []
        for (let i in this.im.items) if (this.im.items[i].imStatus != 3) noNeedReviewMemo.push(this.im.items[i])
        this.selectedM = noNeedReviewMemo
        this.selectedMBool = true
        //- this.selectedM = [""]
        //- 
      }
    },

    selectAllToggle(props) {
      // if(props.value == true){
      //   this.selected = [];
      //    props.items.forEach(item => {
      //      if(item.imStatus != 3 ) {
      //        this.selected.push(item);
      //      }
      //    });
      // }

      // if(this.selected.length != props.items.length  && props.value == true){
      //     console.log(this.selected)
      //     console.log(props)
      //     props.value = false
      // }
       
        if(props.value == false && this.selected.length != 0){
            this.selected = [];
            window.location.replace()
          }
        if(this.selected.length != props.items.length - 1 && props.items.length > 1) {

          if(props.value == true && this.selected.length != 0){
            this.selected = [];
          }else{
            this.selected = [];
              const self = this;
          props.items.forEach(item => {
            if(item.imStatus != 3) {
              self.selected.push(item);
            } 
          });
          } 
        }
        else{
          if(this.selected.length != props.items.length && props.items.length == 1) {
          this.selected = [];
          const self = this;
          props.items.forEach(item => {
            if(item.imStatus != 3) {
              self.selected.push(item);
            } 
          });
        }else{
          this.selected = [];
          }
      }
    },
    onResize() {
      this.isMobile = window.innerWidth < 600;
      if (!this.isMobile){
        window.location.replace()
      }
    },
    toggleShowMore(id) {
      this.$set(this.showMore, id, !this.showMore[id]);
    },
    setShortPerihal(imNo) {
      if (imNo.length > 70) {
        return imNo.substring(0, 70) + " ... ";
      }
      return imNo;
    },
    handleClose() {
      this.approval = "";
      this.comment = ""
      this.approvalDialog = false;
      this.otpcode = null;
      document.getElementById("clear-otp").click()
      this.alert_otp_error = false
    },
    otpOnChange(value) {
      this.otpcode = value;
    },
    handleOnComplete(value) {
      this.otpcode = value;
    },
    getStatus(data, type, dataWf) {
      if (type == "status") {
        if (dataWf[0].status == 5) {
          if (data.status == 5) {
            return this.i18n.status[data.status].color;
          }
          return this.i18n.status[1].color;
        } else {
          if (data.status == undefined) {
            return this.i18n.status[1].color;
          }
          return this.i18n.status[data.status].color;
        }
      } else if (type == "icon") {
        if (dataWf[0].status == 5) {
          if (data.status == 5) {
            return this.i18n.status[data.status].icon;
          }
          return;
        } else {
          if (data.status == undefined) {
            return;
          }
          return this.i18n.status[data.status].icon;
        }
      }
    },
    clickColumn(item) {
      const indexExpanded = this.expanded.findIndex((i) => i._id === item._id);
      if (indexExpanded > -1) {
        this.expanded.splice(indexExpanded, 1);
      } else {
        this.expanded.splice(indexExpanded, 1);
        this.expanded.push(item);
      }
    },
    cancel() {
      this.request.cancel();
    },
    getOptions() {
      this.selected = []
      let url;
      if (this.typeTab == "pending") {
        url = process.env.VUE_APP_API + `/requests/approval/pending/`;
      }
      if (this.typeTab == "approved" || this.typeTab == "rejected") {
        url = process.env.VUE_APP_API + `/requests/approval/history/`;
      }

      clearTimeout(this._timerId);
      if (this.request) this.cancel();

      this._timerId = setTimeout(() => {
        this.im.items = [];
        this.loading = true;
        const search = this.bisnisUnit + "_" + this.keyword;

        if (this.options.page == undefined) {
          this.options.page = 1;
        }

        if (this.options.rowsPerPage == undefined) {
          this.options.rowsPerPage = this.itemsPerPage;
        }

        const axiosSource = axios.CancelToken.source();
        this.request = { cancel: axiosSource.cancel };
        if (search.length != 2 && !this.options.sortBy) {
          axios
            .get(
              url +
                `${this.$route.params.token}?type=${
                  this.typeTab
                }&query=${search.trim()}&page=${this.options.page}&per_page=${
                  this.options.rowsPerPage
                }`
            )
            .then((res) => {
              for (let i in res.data.data) {
                let d = res.data.data[i]
                d.checked = false
                d.subtDate = d.imDate.substring(0,10)
                for (let j = d.imWorkflow.length-1; j >= 0; j--) {
                  if (d.imWorkflow[j].date) {
                    res.data.data[i].subtDateAR = d.imWorkflow[j].date.substring(0, 10)
                    break;
                  }
                }
              }
              this.im.items = res.data.data;
              this.im.jumlah = res.data.total;
              this.request = null;
              this.getIM();
              this.expanded = this.im.items
              this.initDT()
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => (this.loading = false));
        } else if (this.options.sortBy) {
          const direction = this.options.sortDesc[0] ? -1 : 1;
          let sortBy = this.options.sortBy;
          if (sortBy == "imNilai") sortBy = "imValue";
          if (sortBy == "imStatusLabel") sortBy = "imStatus";

          axios
            .get(
              url +
                `${this.$route.params.token}?type=${
                  this.typeTab
                }&query=${search.trim()}&category=${
                  this.category
                }&direction=${direction}&sortBy=${sortBy}&page=${
                  this.options.page
                }&per_page=${this.options.rowsPerPage}`
            )
            .then((res) => {
              for (let i in res.data.data) {
                let d = res.data.data[i]
                d.checked = false
                d.subtDate = d.imDate.substring(0,10)
                for (let j = d.imWorkflow.length-1; j >= 0; j--) {
                  if (d.imWorkflow[j].date) {
                    res.data.data[i].subtDateAR = d.imWorkflow[j].date.substring(0, 10)
                    break;
                  }
                }
              }
              this.im.items = res.data.data;
              this.im.jumlah = res.data.total;
              this.request = null;
              this.getIM();
              this.expanded = this.im.items
              this.initDT()
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => (this.loading = false));
        } else if (search.length == 2) {
          axios
            .get(
              url +
                `${this.$route.params.token}?type=${this.typeTab}&page=${this.options.page}&per_page=${this.options.rowsPerPage}`
            )
            .then((res) => {
              for (let i in res.data.data) {
                let d = res.data.data[i]
                d.checked = false
                d.subtDate = d.imDate.substring(0,10)
                for (let j = d.imWorkflow.length-1; j >= 0; j--) {
                  if (d.imWorkflow[j].date) {
                    res.data.data[i].subtDateAR = d.imWorkflow[j].date.substring(0, 10)
                    break;
                  }
                }
                //- if (isFound) d.subtDateAR = isFound
              }
              this.im.items = res.data.data;
              this.im.jumlah = res.data.total;
              this.request = null;
              this.getIM();
              this.expanded = this.im.items
              this.initDT()
              //- console.log(this.im.items)
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => (this.loading = false));
        }
      }, 500);
    },
    getUTC7Date(tgl) {
      let tanggal = new Date(tgl);
      let month =
        tanggal.getMonth() + 1 < 10
          ? "0" + (tanggal.getMonth() + 1)
          : tanggal.getMonth() + 1;
      let date =
        tanggal.getDate() < 10 ? "0" + tanggal.getDate() : tanggal.getDate();
      return tanggal.getFullYear() + "-" + month + "-" + date;
    },
    download(files) {
      for (const key in files) {
        window.open(files[key].url, "_blank");
      }
    },
    isReviewer(workflow, dataUsers) {
      let result = false;
      let approver = false;
      for (var i = workflow.length - 1; i >= 0; i--) {
        if (workflow[i].status == 3) approver = true;
        if (workflow[i].status == 3 && dataUsers._id == workflow[i].user_id) {
          result = true;
          break;
        }
      }
      if (!approver && i == -1) result = true;
      return result;
    },
    getReviewer(im) {
      let approver = false;
      for (var i = im.imWorkflow.length - 1; i >= 0; i--) {
        if (im.imWorkflow[i].status == 3) return im.imWorkflow[i];
      }
      if (!approver && i == -1) return im.imUser;
    },
    getPreview(id) {
      const URL =
        process.env.VUE_APP_API_OLD +
        `/page-approval/${id}/${this.im.token_be}`;
      window.open(URL, "_blank");
    },
    getIM() {
      if (this.im.items) {
        for (let i = 0; i < this.im.items.length; i++) {
          this.im.items[i].imStatusLabel =
            this.i18n.status[this.im.items[i].imStatus].name;
          this.im.items[i].imTypeLabel =
            this.i18n.imType[this.im.items[i].imType];
          if (this.im.items[i].imStatus == 2) {
            let workflow = this.im.items[i].imWorkflow;
            for (let j = 0; j < workflow.length; j++) {
              this.im.items[i].imStatusLabel =
                this.i18n.status[this.im.items[i].imStatus].name;
              if (workflow[j].status == 9) {
                this.im.items[i].imStatusLabel =
                  this.i18n.status[workflow[j].status].name;
                break;
              }
            }
          }
          this.im.items[i].imUserName = this.im.items[i].imUser.fullname;

          if (this.im.items[i].hasOwnProperty("imCategory")) {
            for (const data of this.i18n.category) {
              if (data.value == this.im.items[i].imCategory) {
                this.im.items[i].imCategory = data.text;
              }
            }
          } else {
            this.im.items[i].imCategory = "General";
          }
        }
      }
      return this.im;
    },

    genOtp() {
      let idIm = [];
      if (this.isMobile) {
        this.numberIm = []
        this.selectedM.forEach((element) => {
          idIm.push(element._id);
          this.numberIm.push(element.imNo)
        });
      } else {

        this.selected.forEach((element) => {
          idIm.push(element._id);
        });
      }
      const config = {
        method: "post",
        url:
          process.env.VUE_APP_API_OLD +
          `/multi/gen-otp/generate/${this.im.token_be}`,
        data: { payload: idIm },
      };
      axios(config).then((res) => {
        if (res.data == "OK") {
          this.alert_otp = true;
        }
      });
    },
    resendOtp() {
      let idIm = [];
      if (this.isMobile) {
        this.selectedM.forEach((element) => {
          idIm.push(element._id);
          this.numberIm.push(element.imNo)
        });
      } else {
        this.selected.forEach((element) => {
          idIm.push(element._id);
        });
      }

      const config = {
        method: "post",
        url:
          process.env.VUE_APP_API_OLD +
          `/multi/gen-otp/resend/${this.im.token_be}`,
        data: { payload: idIm },
      };
      axios(config).then((res) => {
        if (res.data == "OK") {
          this.alert_otp = true;
        }
      });
    },
    sendNotifAppovalMulti(data, status) {
      const config = {
        method: "post",
        url: process.env.VUE_APP_API_OLD + `/sendNotif/${this.im.token_be}`,
        headers: { Authorization: `Bearer ${this.im.token_be}` },
        data: { payload: data, status: status },
      };
      axios(config).then(() => {
        location.reload();
      });
    },
    SubmitApprove() {
      if (this.isMobile) {
        this.selectedM.forEach((el) => {
        var qString = {_id: el._id, status: parseInt(this.approval), comment: this.comment, backto: parseInt(this.approval) == 3 ? this.select : null, otp: this.otpcode}

        const config = {
          method: "put",
          url: process.env.VUE_APP_API_OLD+`/api/update/requests/multi/${this.im.token_be}`,
          headers: {"Authorization": `Bearer ${this.im.token_be}`},
          data: qString
        };


        axios(config).then(res => {
          if (res.status == 200) {
            if(res.data.error){
              document.getElementById("clear-otp").click()
              this.alert_otp = "error-otp"
              this.alert_otp_error = true
              this.multiLoading = false
              this.otpcode = ''
            }else{
              this.length_data.push({imNo: el.imNo, imPerihal: el.imPerihal})
              if(this.length_data.length == this.selectedM.length){
                this.multiLoading = false
                location.reload(); 
                // this.sendNotifAppovalMulti(this.length_data,parseInt(this.approval))            
              }
            }

            }
        })

      });
      } else {
        this.selected.forEach((el) => {
        var qString = {_id: el._id, status: parseInt(this.approval), comment: this.comment, backto: parseInt(this.approval) == 3 ? this.select : null, otp: this.otpcode}

        const config = {
          method: "put",
          url: process.env.VUE_APP_API_OLD+`/api/update/requests/multi/${this.im.token_be}`,
          headers: {"Authorization": `Bearer ${this.im.token_be}`},
          data: qString
        };


        axios(config).then(res => {
          if (res.status == 200) {
            if(res.data.error){
              document.getElementById("clear-otp").click()
              this.alert_otp = "error-otp"
              this.alert_otp_error = true
              this.multiLoading = false
              this.otpcode = ''
            }else{
              this.length_data.push({imNo: el.imNo, imPerihal: el.imPerihal})
              if(this.length_data.length == this.selected.length){
                this.multiLoading = false
                location.reload(); 
                // this.sendNotifAppovalMulti(this.length_data,parseInt(this.approval))            
              }
            }

            }
        })

      });
      }

    },
  },
};
</script>

<style scoped>
.v-data-footer__icons-after::after{
content: " - Remember this";
}


.pointer {
  cursor: pointer;
}
</style>



